// Function loadArticleList loads the ArticleList class by dynamically importing the js on demand if needed

export function loadArticleList($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="ArticleList"]');

	if(!$wg) {
		// console.info('ArticleList: no widget found');
		return Promise.reject('ArticleList widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-article-list-chunk" */ '../widgets/articleList').then(wg => {

		const { ArticleList } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ArticleList"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new ArticleList($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ArticleList($wg);
		}


	}).catch(error => error+'An error occurred while loading the ArticleList widget');

}
